var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
// Mapping between heading size, HTML elements, and actual font size
var sizeMap = {
    xxlarge: {
        fontSize: tokens.fontSizes.xxlarge,
        element: 'h1',
    },
    xlarge: {
        element: 'h2',
        fontSize: tokens.fontSizes.xlarge,
    },
    large: {
        element: 'h3',
        fontSize: tokens.fontSizes.large,
    },
    medium: {
        element: 'h4',
        fontSize: tokens.fontSizes.medium,
    },
};
export function headingStyle(_a) {
    var size = _a.size, inverted = _a.inverted;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    margin-bottom: ", ";\n    line-height: ", ";\n  "], ["\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    margin-bottom: ", ";\n    line-height: ", ";\n  "])), inverted ? tokens.colors.white : tokens.colors.navy, tokens.fontWeights.bold, sizeMap[size].fontSize, tokens.spacing.small, tokens.lineHeights.default);
}
export function sizeToElement(_a) {
    var size = _a.size;
    return sizeMap[size].element;
}
var templateObject_1;
